import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ModuleManagerSetting } from 'src/shared/models/module-manager/module-manager-setting.model';
import { ReportObject } from '../../modules/quality-evaluations/cxone-quality-evaluations.model';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CxoneQualityEvaluationsService } from '../../modules/quality-evaluations/cxone-quality-evaluations.service';

@Component({
	selector: 'cv-cxone-quality-evaluations-settings',
	templateUrl: './cxone-quality-evaluations-settings.component.html',
	styleUrls: ['./cxone-quality-evaluations-settings.component.scss']
})
export class CxoneQualityEvaluationsSettingsComponent implements OnInit {

	@Input() moduleManager: ModuleManager;

	definitions = [];
	selectedReport: ReportObject;
	selectedReportName = '';

	constructor(
		private cvLocalizationService: CVLocalizationService,
		private qualityEvaluationsService: CxoneQualityEvaluationsService
	) { }

	ngOnInit() {
		this.cvLocalizationService.GetSection('CXOne_Quality_Evaluations_Settings');

		this.moduleManager.addSetting({
			name: 'reportingSetName',
			required: true,
			onMissingValue: () => {
				this.selectedReportName = 'Evaluation Details';
			},
			getValue: () => this.selectedReportName,
			onSettingLoaded: (value) => {
				if (!value) return;

				this.selectedReportName = value;
				if (this.definitions.length) {
					this.selectedReport = this.definitions.find(rs => rs.ReportingSetName === value);
					this.onReportSelected();
				}
			},
			defaultValue: 'Evaluation Details',
		} as ModuleManagerSetting<string>);

		this.moduleManager.customSettingsAdded = true;
		this.loadData();
	}

	async loadData() {
		const response = await this.qualityEvaluationsService.getReportList();
		this.definitions = response?.data?.map(report => ({ ReportingSetName: report?.ReportingSetDefinition.ReportingSetName, displayName: report?.ReportingSetDefinition?.DisplayName }));
		this.selectedReport = this.selectedReportName
			? this.definitions.find(rs => rs.ReportingSetName === this.selectedReportName)
			: this.definitions[0];
		this.onReportSelected();
	}

	onReportSelected() {
		this.selectedReportName = this.selectedReport?.ReportingSetName || '';
	}

	onReportChanged(change: string) {
		this.selectedReport = this.definitions.find(d => d.ReportingSetName === change);
		this.onReportSelected();
	}
}